import translations from '../../components/location/ts/lv-LV';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('lv-LV', translations);
